import React from 'react';
import {
  colors,
  makeStyles,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { Create, List as ListIcon, Home, Bookmark } from '@material-ui/icons';
import { Link, useLocation } from 'react-router-dom';

import Routes from 'config/routes';

import Description from 'components/typography/Description';

const useStyles = makeStyles({
  root: {
    width: '100%',
    backgroundColor: colors.red[400],
    borderRadius: 8,
    padding: 0,
    overflow: 'hidden',
  },
  item: {
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  link: {
    textDecoration: 'none',
  },
  text: {
    color: colors.grey[50],
  },
  icon: {
    color: colors.grey[50],
  },
  itemWithBorder: {
    borderBottom: `1px solid ${colors.grey[50]}`,
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const UserMenu = () => {
  const classes = useStyles();
  const location = useLocation();

  const link = (route) => ({
    pathname: route,
    state: { from: location },
  });

  return (
    <Paper elevation={3} className={classes.root}>
      <List>
        <Link to={link(Routes.HOME_PAGE)} className={classes.link}>
          <Item>
            <ListItemIcon>
              <Home className={classes.icon}></Home>
            </ListItemIcon>
            <ListItemText className={classes.text}>
              <Description>
                <b>HOME</b>
              </Description>
            </ListItemText>
          </Item>
        </Link>

        <Link to={link(Routes.createRecipe())} className={classes.link}>
          <Item>
            <ListItemIcon>
              <Create className={classes.icon}></Create>
            </ListItemIcon>
            <ListItemText className={classes.text}>
              <Description>
                <b>CREATE RECIPE</b>
              </Description>
            </ListItemText>
          </Item>
        </Link>

        <Link to={link(Routes.MY_RECIPES)} className={classes.link}>
          <Item>
            <ListItemIcon>
              <ListIcon className={classes.icon}></ListIcon>
            </ListItemIcon>
            <ListItemText className={classes.text}>
              <Description>
                <b>MY RECIPES</b>
              </Description>
            </ListItemText>
          </Item>
        </Link>

        <Link to={link(Routes.BOOKMARKS)} className={classes.link}>
          <ListItem button className={classes.item}>
            <ListItemIcon>
              <Bookmark className={classes.icon}></Bookmark>
            </ListItemIcon>
            <ListItemText className={classes.text}>
              <Description>
                <b>BOOKMARKED</b>
              </Description>
            </ListItemText>
          </ListItem>
        </Link>
      </List>
    </Paper>
  );
};

const Item = ({ children, showBottomLine = true }) => {
  const classes = useStyles();

  return (
    <ListItem
      button
      className={showBottomLine ? classes.itemWithBorder : classes.item}
    >
      {children}
    </ListItem>
  );
};

export default UserMenu;
